import React, { forwardRef, MouseEvent } from 'react';
import MuiButton, { ButtonProps } from '@material-ui/core/Button';
import { isUndefined } from 'lodash-es';
import Tooltip from '@material-ui/core/Tooltip';

export type ButtonVariant = 'outlined' | 'contained' | 'text';
export type ButtonColor = 'inherit' | 'primary' | 'secondary' | 'danger' | 'default';

export interface Props extends ButtonProps {
    label?: React.ReactNode;
    tooltip?: React.ReactNode;
    noWrap?: boolean;
    labelDeco?: string;
}

const Button = forwardRef<HTMLButtonElement, Props>(
    (
        {
            label,
            tooltip,
            variant = 'contained',
            onClick,
            size = 'medium',
            color = 'primary',
            children,
            noWrap = true,
            labelDeco,
            ...other
        },
        ref
    ) => {
        const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
            if (!isUndefined(onClick)) {
                event.stopPropagation();
                onClick(event);
            }
        };

        const content = label ? (
            <div style={{ whiteSpace: noWrap ? 'nowrap' : undefined }}>{label}</div>
        ) : (
            children
        );

        const button = (
            <MuiButton
                ref={ref}
                aria-label={typeof label === 'string' ? label : undefined}
                variant={variant}
                size={size}
                color={color}
                onClick={handleClick}
                endIcon={
                    labelDeco ? <i className='material-icons-outlined'>{labelDeco}</i> : undefined
                }
                {...other}
            >
                {content}
            </MuiButton>
        );

        return tooltip ? (
            <Tooltip title={tooltip} placement='bottom-end'>
                {/* Tooltip needs a wrapper element */}
                <div>{button}</div>
            </Tooltip>
        ) : (
            button
        );
    }
);

Button.displayName = 'Button';
export default Button;
